/**
 * Dialog drill-down rincian jadwal proyek (user request F — 2026-10-21).
 * Read-only: menampilkan field kanonis dari backend (project_schedule_engine).
 * Frontend TIDAK menghitung ulang tanggal.
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDate } from "@/lib/constants";

const STATUS_LABEL = {
  on_track: "Dalam jadwal",
  not_started: "Belum dimulai",
  due_today: "Berakhir hari ini",
  overdue: "Jadwal Proyek Terlambat (melewati tanggal selesai kontrak)",
  completed_early: "Selesai lebih awal",
  completed_on_time: "Selesai tepat waktu",
  completed_late: "Selesai terlambat",
  completed_missing_date: "Tanggal penyelesaian belum diisi",
  no_end_date: "Tanggal selesai belum diisi",
  no_schedule: "Jadwal belum diisi",
  not_applicable: "Tidak berlaku",
  cancelled: "Dibatalkan",
};

export default function ScheduleDrilldownDialog({ open, onClose, sched }) {
  if (!sched) sched = {};
  const rows = [
    ["Tanggal Mulai", sched.start_date ? fmtDate(sched.start_date) : "—", "mulai"],
    ["Tanggal Selesai Rencana", sched.end_date ? fmtDate(sched.end_date) : "—", "selesai-rencana"],
    ["Tanggal Efektif Perhitungan", sched.effective_date ? fmtDate(sched.effective_date) : "—", "efektif"],
    ...(sched.completed_date ? [["Tanggal Selesai Aktual", fmtDate(sched.completed_date), "selesai-aktual"]] : []),
    ["Zona Waktu", sched.timezone || "Asia/Jakarta", "tz"],
    ["Total Durasi", sched.total_duration_days != null ? `${sched.total_duration_days} hari` : "—", "total"],
    ["Hari Terpakai", sched.elapsed_days != null ? `${sched.elapsed_days} hari` : "—", "terpakai"],
    ["Hari Tersisa", sched.remaining_days != null ? `${sched.remaining_days} hari` : "—", "tersisa"],
    ["Hari Keterlambatan", sched.overdue_days ? `${sched.overdue_days} hari` : "0 hari", "overdue"],
    ["Status Jadwal", sched.completed_label || STATUS_LABEL[sched.schedule_status] || sched.schedule_status || "—", "status"],
    ...(sched.completed_delta_days != null ? [["Deviasi vs Tanggal Rencana", `${sched.completed_delta_days > 0 ? "+" : ""}${sched.completed_delta_days} hari`, "delta"]] : []),
  ];
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-sm" data-testid="schedule-drilldown-dialog" aria-describedby="schedule-dd-desc">
        <DialogHeader>
          <DialogTitle className="text-[#0B1D3A]">Rincian Sisa Waktu Proyek</DialogTitle>
          <p id="schedule-dd-desc" className="text-[11px] text-slate-500">
            Nilai berasal dari <b>project_schedule_engine</b> (backend) — rumus EKSKLUSIF
            <code className="mx-1 px-1 bg-slate-100 text-[10px]">end_date − start_date</code>,
            tanggal acuan zona waktu Asia/Jakarta. Frontend tidak menghitung ulang.
          </p>
        </DialogHeader>
        <div className="divide-y divide-slate-100 text-xs">
          {rows.map(([label, val, k]) => (
            <div key={k} className="flex items-center justify-between py-1.5 gap-3">
              <span className="text-slate-500">{label}</span>
              <span className="font-semibold tabular-nums text-[#0B1D3A] text-right" data-testid={`schedule-dd-${k}`}>{val}</span>
            </div>
          ))}
        </div>
        <div className="mt-2 text-[10px] text-slate-400 italic" data-testid="schedule-dd-source">
          Sumber data: {sched.source || "project_schedule_engine"} — identik dengan Daftar Proyek, Monitoring, Dashboard, dan ekspor.
        </div>
      </DialogContent>
    </Dialog>
  );
}
